import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { ButtonComponent } from './button/button.component';
import { CustomInputComponent } from './custom-input/custom-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CustomDropDownComponent } from './custom-drop-down/custom-drop-down.component';
import { CustomCheckboxComponent } from './custom-checkbox/custom-checkbox.component';
import { FilterTagComponent } from './filter-tag/filter-tag.component';
import { NotLoggedLayoutComponent } from './layouts/not-logged-layout/not-logged-layout.component';
import { EtablissementLayoutComponent } from './layouts/etablissement-layout/etablissement-layout.component';
import { CandidatLayoutComponent } from './layouts/candidat-layout/candidat-layout.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CandidatHeaderComponent } from './core/candidat-header/candidat-header.component';
import { NotificationPanelComponent } from './components/notification-panel/notification-panel.component';
import { DefaultHeaderComponent } from './core/default-header/default-header.component';
import { EtablissementHeaderComponent } from './core/etablissement-header/etablissement-header.component';
import { SidebarComponent } from './core/sidebar/sidebar.component';
import { CustomDragdropImageComponent } from './custom-dragdrop-image/custom-dragdrop-image.component';
import { AlertModalComponent } from './alert-modal/alert-modal.component';
import { PhoneNumberInputComponent } from './phone-number-input/phone-number-input.component';
import { TagComponent } from './tag/tag.component';
import { DataTableComponent } from './data-table/data-table.component';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { StatusMissionPipe } from './pipes/status-mission.pipe';
import { UserComponent } from './user/user.component';
import { RatingComponent } from './rating/rating.component';
import { CustomDialogComponent } from './custom-dialog/custom-dialog.component';
import { CustomFlagComponent } from './custom-flag/custom-flag.component';
import { CustomSideBarComponent } from './custom-side-bar/custom-side-bar.component';
import { DateCellComponent } from './data-table/date-cell/date-cell.component';
import { TitleCellComponent } from './data-table/title-cell/title-cell.component';
import { VisibilityComponent } from './components/visibility/visibility.component';
import { PhotosComponent } from './components/photos/photos.component';
import { AddressMenuComponent } from './components/address-menu/address-menu.component';
import { TextSeparatorComponent } from './text-separator/text-separator.component';
import { NumberCellComponent } from './data-table/number-cell/number-cell.component';
import { CurrencyCellComponent } from './data-table/currency-cell/currency-cell.component';
import { PersonnelActionComponent } from './components/personnel-action/personnel-action.component';
import { PhoneDatableComponent } from './components/phone-datable/phone-datable.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ServiceAffectationActionComponent } from './components/service-affectation-action/service-affectation-action.component';
import { CustomBreadcrumbComponent } from './custom-breadcrumb/custom-breadcrumb.component';
import { LoaderComponent } from './loader/loader.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './calendar/calendar.component';
import { BannerComponent } from './banner/banner.component';
import { TextIconComponent } from './text-icon/text-icon.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import {
  NgxExtendedPdfViewerModule,
  NgxExtendedPdfViewerService,
} from 'ngx-extended-pdf-viewer';
import { DisplayPdfDialogComponent } from './upload-file/components/display-pdf-dialog/display-pdf-dialog.component';
import { CookieService } from 'ngx-cookie-service';
import { CustomDatepickerComponent } from './custom-datepicker/custom-datepicker.component';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MapComponent } from './map/map.component';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { StausCandidatMissionPipe } from './pipes/staus-candidat-mission.pipe';
import { StatusCandidatMissionComponent } from './status-candidat-mission/status-candidat-mission.component';
import { CandidatMissionStatusPipe } from './pipes/candidat-mission-status.pipe';
import { StausCandidatMissionColorPipe } from './pipes/staus-candidat-mission-color.pipe';
import { StausCandidatMissionColorEnumsPipe } from './pipes/staus-candidat-mission-color-enums.pipe';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { DocuSignDialogComponent } from './docu-sign-dialog/docu-sign-dialog.component';
import { ImageDialogComponent } from './image-dialog/image-dialog.component';
import { UserActionComponent } from './components/user-action/user-action.component';
import { AgencyManagementActionComponent } from './components/agency-management-action/agency-management-action.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
// import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    ButtonComponent,
    CustomInputComponent,
    CustomDropDownComponent,
    CustomCheckboxComponent,
    DataTableComponent,
    FilterTagComponent,
    NotLoggedLayoutComponent,
    EtablissementLayoutComponent,
    CandidatLayoutComponent,
    CandidatHeaderComponent,
    DefaultHeaderComponent,
    EtablissementHeaderComponent,
    SidebarComponent,
    CustomDragdropImageComponent,
    TagComponent,
    AlertModalComponent,
    PhoneNumberInputComponent,
    StatusMissionPipe,
    StausCandidatMissionPipe,
    UserComponent,
    RatingComponent,
    CustomDialogComponent,
    CustomFlagComponent,
    CustomSideBarComponent,
    DateCellComponent,
    TitleCellComponent,
    VisibilityComponent,
    PhotosComponent,
    AddressMenuComponent,
    TextSeparatorComponent,
    NumberCellComponent,
    CurrencyCellComponent,
    CustomBreadcrumbComponent,
    LoaderComponent,
    CalendarComponent,
    PersonnelActionComponent,
    PhoneDatableComponent,
    ServiceAffectationActionComponent,
    BannerComponent,
    TextIconComponent,
    CarouselComponent,
    UploadFileComponent,
    DisplayPdfDialogComponent,
    CustomDatepickerComponent,
    MapComponent,
    StatusCandidatMissionComponent,
    CandidatMissionStatusPipe,
    StausCandidatMissionColorPipe,
    StausCandidatMissionColorEnumsPipe,
    DocuSignDialogComponent,
    ImageDialogComponent,
    UserActionComponent,
    AgencyManagementActionComponent,
    MessageDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    // BreadcrumbModule,

    ReactiveFormsModule,
    AngularSvgIconModule.forRoot(),
    NgxExtendedPdfViewerModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),

    RouterOutlet,
    RouterLink,
    NgOptimizedImage,
    NgxIntlTelInputModule,
    MomentDateModule,
    // PdfViewerModule,
    TooltipModule.forRoot(),
    MatRadioGroup,
    MatRadioButton,
    NgxDocViewerModule,
    NotificationPanelComponent,
    HasPermissionDirective,
    // InfiniteScrollModule,
  ],
  exports: [
    UserActionComponent,
    HasPermissionDirective,
    ButtonComponent,
    RatingComponent,
    CustomDragdropImageComponent,
    CustomInputComponent,
    CustomCheckboxComponent,
    DataTableComponent,
    FilterTagComponent,
    StausCandidatMissionColorEnumsPipe,
    FormsModule,
    CustomDropDownComponent,
    PhoneNumberInputComponent,
    TextSeparatorComponent,
    StausCandidatMissionColorPipe,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    TagComponent,
    StatusMissionPipe,
    StausCandidatMissionPipe,
    CandidatMissionStatusPipe,
    UserComponent,
    // BreadcrumbModule,
    CustomSideBarComponent,
    CustomBreadcrumbComponent,
    LoaderComponent,
    CalendarComponent,
    BannerComponent,
    TextIconComponent,
    CarouselComponent,
    UploadFileComponent,
    CustomDatepickerComponent,
    MapComponent,
    NgxDocViewerModule,
    SidebarComponent,
    // InfiniteScrollModule,
    // TooltipModule
  ],
  providers: [NgxExtendedPdfViewerService, CookieService],
})
export class SharedModule {}
